export default {
  cachedFetch(state) {
    return state.cachedFetch;
  },
};
